<div class="page-sub-title">New Event</div>
<div class="wizard-step" *ngIf="currentStep === 'TYPESELECT'">
    <div class="format-choice-intro">Choose an event format</div>
    <div class="format-choice-grid">
        <button
            type="button"
            class="format-choice-card"
            *ngFor="let option of visibleFormatOptions"
            [ngClass]="{ selected: createGolfEventRequest.type === option.type }"
            (click)="selectEventType(option.type)"
        >
            <div class="format-choice-name">{{ option.name }}</div>
            <div class="format-choice-description">{{ option.description }}</div>
        </button>
    </div>
    <button (click)="cancel()" class="cancel">Cancel</button>
</div>
<div class="wizard-step" *ngIf="currentStep === 'EVENTINFO'">
    <form #form="ngForm" class="form">

        <div class="table-container">
            <table>
                <thead>
                    <tr><th>Golf Event Details</th></tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <div class="field">
                                <input type="text" name="eventName" required [(ngModel)]="createGolfEventRequest.eventName" #eventNameModel="ngModel" name="eventName" placeholder=" " />
                                <label>Event Name</label>
                                <span class="error" *ngIf="eventNameModel.invalid && eventNameModel.touched">
                                    Event Name is required
                                </span>
                            </div>
                            <div class="field">
                                <textarea name="eventDescription" required [(ngModel)]="createGolfEventRequest.description" #eventDescriptionModel="ngModel" name="eventDescription" placeholder=" "></textarea>
                                <label>Event Details</label>
                                <span class="error" *ngIf="eventDescriptionModel.invalid && eventDescriptionModel.touched">
                                    Details are required
                                </span>
                            </div>
                            <div class="field">
                                <input
                                type="date"
                                name="startDate"
                                required
                                [(ngModel)]="createGolfEventRequest.startDate"
                                #startDateModel="ngModel"
                                />
                                <label class="static">Event Start Date</label>
                                <span class="error" *ngIf="startDateModel.invalid && startDateModel.touched">
                                    Start Date is required
                                </span>
                            </div>
                            <div class="field">
                                <input
                                type="date"
                                name="endDate"
                                required
                                [(ngModel)]="createGolfEventRequest.endDate"
                                #endDateModel="ngModel"
                                />
                                <label class="static">Event End Date</label>
                                <span class="error" *ngIf="endDateModel.invalid && endDateModel.touched">
                                    End Date is required
                                </span>
                            </div>
                            <div class="field">
                                <input type="text" name="entryFee" required [(ngModel)]="createGolfEventRequest.entryFee" #entryFeeModel="ngModel" name="entryFee" placeholder=" " />
                                <label>Entry Fee</label>
                                <span class="error" *ngIf="entryFeeModel.invalid && entryFeeModel.touched">
                                    Entry fee required
                                </span>
                            </div>
                            <div class="field">
                                <input
                                    type="text"
                                    name="firstPlacePrizeMoney"
                                    required
                                    pattern="^[0-9]+(\.[0-9]{1,2})?$"
                                    [(ngModel)]="createGolfEventRequest.firstPlacePrizeMoney"
                                    #firstPlaceModel="ngModel"
                                    placeholder=" "
                                />
                                <label>First Place Prize</label>
                                <span class="error" *ngIf="firstPlaceModel.invalid && firstPlaceModel.touched">
                                    Valid amount required
                                </span>
                            </div>
                            <div class="field">
                                <input
                                    type="text"
                                    name="secondPlacePrizeMoney"
                                    required
                                    pattern="^[0-9]+(\.[0-9]{1,2})?$"
                                    [(ngModel)]="createGolfEventRequest.secondPlacePrizeMoney"
                                    #secondPlaceModel="ngModel"
                                    placeholder=" "
                                />
                                <label>Second Place Prize</label>
                                <span class="error" *ngIf="secondPlaceModel.invalid && secondPlaceModel.touched">
                                    Valid amount required
                                </span>
                            </div>
                            <div class="field">
                                <input
                                    type="text"
                                    name="thirdPlacePrizeMoney"
                                    required
                                    pattern="^[0-9]+(\.[0-9]{1,2})?$"
                                    [(ngModel)]="createGolfEventRequest.thirdPlacePrizeMoney"
                                    #thirdPlaceModel="ngModel"
                                    placeholder=" "
                                />
                                <label>Third Place Prize</label>
                                <span class="error" *ngIf="thirdPlaceModel.invalid && thirdPlaceModel.touched">
                                    Valid amount required
                                </span>
                            </div>   
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <button (click)="moveToStep('FORMAT')">Next: Scoring ></button>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <button (click)="moveToStep('TYPESELECT')" class="cancel">&lt; Back</button>
                            <button (click)="cancel()" class="cancel">Cancel</button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </form>
    
</div>
<div class="wizard-step" *ngIf="currentStep === 'FORMAT'">
    <form #form="ngForm" class="form">
        <div class="table-container">
            <table>
                <thead>
                    <tr><th>Scoring Details</th></tr>
                </thead>
                <tbody>
                    <tr>
                        <td colspan="2">
                            <p class="format-help">Leaderboards are always score to par (under/over par for counted rounds).</p>
                            <p class="format-help" *ngIf="isHybridScramble">
                                Hybrid Scramble scoring is fixed: individual standings, net scores with team handicaps,
                                and the best X net rounds per course are averaged before the course scores are added up.
                            </p>
                            <div class="field" *ngIf="!isHybridScramble">
                                <select
                                    name="scoreAggregation"
                                    required
                                    [(ngModel)]="createGolfEventRequest.scoreAggregation"
                                    #scoreAggregationModel="ngModel"
                                >
                                    <option value="SUM">Sum of best X scores</option>
                                    <option value="AVG">Average of best X scores</option>
                                </select>
                                <label>How Best Scores Combine</label>
                            </div>
                            <div class="checkbox-field" *ngIf="!isHybridScramble">
                                <input
                                type="checkbox"
                                name="teamEvent"
                                required
                                [(ngModel)]="createGolfEventRequest.isTeamEvent"
                                #teamEvent="ngModel"
                                id="teamEvent"
                                />
                                <label for="teamEvent">Is Team Event</label>
                            </div>
                            <div class="checkbox-field" *ngIf="!isHybridScramble">
                                <input
                                type="checkbox"
                                name="useHandicaps"
                                required
                                [(ngModel)]="createGolfEventRequest.useHandicaps"
                                #useHandicaps="ngModel"
                                id="useHandicaps"
                                />
                                <label for="useHandicaps">Use Handicaps</label>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td><button (click)="moveToStep('EVENTINFO')">&lt; Back</button></td>
                        <td><button (click)="goToNextFromFormat()">{{ formatNextLabel }}</button></td>
                    </tr>
                    <tr>
                        <td colspan="2">
                            <button (click)="cancel()" class="cancel">Cancel</button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </form>
    
</div>
<div class="wizard-step" *ngIf="currentStep === 'COURSES'">
    <form #courseForm="ngForm" class="form">
        <div class="table-container" *ngFor="let slot of createGolfEventRequest.courseSlots; let i = index">
            <table>
                <thead>
                    <tr><th>{{ allowsMultipleCourses ? 'Course ' + (i + 1) : 'Course' }}</th></tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <div class="field">
                                <input type="text" name="golfCourseName{{i}}" required [(ngModel)]="slot.golfCourseName" #courseNameModel="ngModel" placeholder=" " />
                                <label>Golf Course Name</label>
                            </div>
                            <div class="field">
                                <input type="text" name="teeLocation{{i}}" required [(ngModel)]="slot.teeLocation" placeholder=" " />
                                <label>Tee Location</label>
                            </div>
                            <div class="field">
                                <input type="text" name="gimmeCircleSize{{i}}" required [(ngModel)]="slot.gimmeCircleSize" placeholder=" " />
                                <label>Gimme Circle Size</label>
                            </div>
                            <div class="field">
                                <select name="pinLocations{{i}}" required [(ngModel)]="slot.pinLocations">
                                    <option value="Thursday">Thursday</option>
                                    <option value="Friday">Friday</option>
                                    <option value="Saturday">Saturday</option>
                                    <option value="Sunday">Sunday</option>
                                </select>
                                <label>Pin Locations</label>
                            </div>
                            <div class="field">
                                <select name="holesToPlay{{i}}" required [(ngModel)]="slot.holesToPlay">
                                    <option value="FRONT9">Front 9</option>
                                    <option value="BACK9">Back 9</option>
                                    <option value="ALL18">All 18</option>
                                </select>
                                <label>Holes To Play</label>
                            </div>
                            <div class="field">
                                <input type="text" name="coursePar{{i}}" required [(ngModel)]="slot.coursePar" placeholder=" " />
                                <label>Course Par</label>
                            </div>
                            <div class="field">
                                <input type="number" name="roundsToCount{{i}}" required [(ngModel)]="slot.roundsToCount" placeholder=" " />
                                <label>Number of rounds to count</label>
                            </div>
                            <div class="field">
                                <input type="number" name="maxRoundsToPost{{i}}" required [(ngModel)]="slot.maxRoundsToPost" placeholder=" " />
                                <label>Max rounds a team/player can post</label>
                            </div>
                            <button type="button" class="cancel" *ngIf="allowsMultipleCourses && createGolfEventRequest.courseSlots.length > 1" (click)="removeCourseSlot(i)">Remove Course</button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <button type="button" *ngIf="allowsMultipleCourses" (click)="addCourseSlot()">Add Course</button>
        <div class="table-container">
            <table>
                <tbody>
                    <tr>
                        <td><button type="button" (click)="moveToStep('FORMAT')">&lt; Back</button></td>
                        <td><button type="button" (click)="moveToStep('PLAYERSELECT')">Next: Set the Field ></button></td>
                    </tr>
                    <tr>
                        <td colspan="2">
                            <button type="button" (click)="cancel()" class="cancel">Cancel</button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </form>
</div>
<div class="wizard-step" *ngIf="currentStep === 'PLAYERSELECT'">
    <form #form="ngForm" class="form">
        <div class="table-container">
            <table>
                <thead>
                    <tr>
                        <th colspan="2">Set the Field</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td colspan="2">
                            <div class="checkbox-list">
                                <label class="checkbox-item" *ngFor="let p of field">
                                    <input
                                    type="checkbox"
                                    [(ngModel)]="p.isSelected"
                                    name="player-{{ p.player.id }}"
                                    />
                                    <span class="checkbox-label">
                                    {{ p.player.firstName }} {{ p.player.lastName }}
                                    </span>
                                </label>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td><button (click)="backFromField()">&lt; Back</button></td>
                        <td> <button (click)="save()">Save Event</button></td>
                    </tr>
                    <tr>
                        <td colspan="2">
                            <button (click)="cancel()" class="cancel">Cancel</button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </form>
</div>
<!--
    <div class="checkbox-list">
        <label class="checkbox-item" *ngFor="let p of field">
            <input
            type="checkbox"
            [(ngModel)]="p.isSelected"
            name="player-{{ p.player.id }}"
            />
            <span class="checkbox-label">
            {{ p.player.firstName }} {{ p.player.lastName }}
            </span>
        </label>
    </div>
    <button (click)="moveToStep('EVENTINFO')">Back</button>
    <button (click)="moveToStep('REVIEW')">Next</button>
</div>
<div class="wizard-step" *ngIf="currentStep === 'REVIEW'">
    <div class="page-sub-title">Review</div>
    <div *ngFor="let p of getFinalField()">
        {{p.player.firstName}} {{p.player.lastName}}
    </div>
    <button (click)="save()">Save Event</button>
</div>-->

